import {apolloClient} from '@/vue-apollo'
import {createDocumentSand, CreateMutationReceiver} from '@/graphql/mutations/Documents.gql'
// eslint-disable-next-line no-unused-vars
import {fileDocument, UploadFile} from '@/graphql/mutations/UploadImage.gql'

const createDocument = async (variables) => {
 const {data:{createDocument}}  = await apolloClient.mutate({
  mutation: createDocumentSand,
  variables
 })
 return createDocument
}


const sendingToDestination = async (variables,id_document) => {
 variables.document = id_document
 console.log(variables)
  const {data: {createReceiver}} = await apolloClient.mutate({
   mutation: CreateMutationReceiver,
   variables,
  })
  return createReceiver
}

const sendingToMe =  async (variables,id_document) => {
 variables.document = id_document
 const data =  await sendingToDestination(variables,id_document)
 return data
}

const filesDocument = async (files,id_document) => {
  let arrayfiles = [];
  for (let filecurrent of files){
   const file = filecurrent.file ?  filecurrent.file : filecurrent
   const data = await apolloClient.mutate({
    mutation:UploadFile,
    variables:{
     file:file
    }
   })
   const dataDocument = await apolloClient.mutate({
    mutation:fileDocument,
    variables:{
     file_name:data.data.upload,
     path: data.data.upload,
     document: id_document
    }
   })
   await arrayfiles.push(dataDocument)
  }

 return arrayfiles
}

export default {
 createDocument,
 sendingToDestination,
 sendingToMe,
 filesDocument
}
